import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Navbar from './Navbar';
import FAQSection from './FAQSection';
import './FAQ.css';

function FAQ() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="faq-page">
      <Navbar />
      <button className="back-button" onClick={() => navigate('/')} aria-label="Go back to home">
        <FaArrowLeft /> Back
      </button>
      
      <div className="faq-page-content">
        <FAQSection />
      </div>
    </div>
  );
}

export default FAQ;
